import { createStyles, makeStyles } from '@mui/styles'

export const useStyles = makeStyles(
    createStyles({
        container: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
        }
    })
)
